import { AlertTriangle } from "lucide-react";
import { useLang } from "../i18n";

export const EmergencyNotice = ({ className = "" }) => {
  const { t } = useLang();
  return (
    <div
      data-testid="emergency-notice"
      role="note"
      className={`flex items-start gap-3 rounded-2xl border border-destructive/25 bg-destructive/5 px-5 py-4 ${className}`}
    >
      <AlertTriangle size={20} className="text-destructive shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-sm text-ink/80 leading-relaxed">
        <span className="font-semibold text-destructive">{t("For emergencies, call 911")}</span>{" "}
        {t("or go to the nearest emergency room. This website is not for urgent or medical emergencies.")}
      </p>
    </div>
  );
};
